import { useTranslation } from 'next-i18next';
import React from 'react';
import {
  SettingBox,
  SettingBoxCenter,
  SettingBoxLeft,
  SettingBoxRight,
} from './styles';
import VolumeSetting from './VolumeSetting';
import LocalizedLink from '@/components/ui/LocalizedLink';
import FavoriteStar from '@/components/biz/FavoriteStar';
import useRecordRecentPlayed from '@/hooks/biz/useRecordRecentPlayed';
import { getStaticAsset } from '@/utils/staticAsset';
import Image from 'next/image';
import { Button } from '@mui/material';

export interface CrashSettingBoxProps {
  isMob?: boolean;
  gameId: string;
  fairnessLink?: string;
  hideVolume?: boolean;
}

export const GameSettings: React.FC<CrashSettingBoxProps> = ({
  isMob,
  gameId,
  fairnessLink,
  hideVolume,
}) => {
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const { t } = useTranslation();
  useRecordRecentPlayed({ gameId });
  return (
    <SettingBox>
      <SettingBoxLeft>
        {!hideVolume && <VolumeSetting />}
        <FavoriteStar gameId={gameId} />
      </SettingBoxLeft>
      <SettingBoxCenter>
        <Image
          width={103}
          height={35}
          alt={'title'}
          src={getStaticAsset('/assets/images/logo/moonclub.svg')}
        />
      </SettingBoxCenter>
      <SettingBoxRight>
        <LocalizedLink href={fairnessLink} target={'_blank'}>
          <Button
            sx={{
              fontSize: '12px',
              height: '30px',
              padding: '4px 8px',
              border: (theme) => theme.palette.border.normal,
              backgroundColor: '#2B3139',
            }}
          >
            {t('Fairness')}
          </Button>
        </LocalizedLink>
      </SettingBoxRight>
    </SettingBox>
  );
};

export default GameSettings;
